module.exports = __webpack_public_path__ + "media/images/ex_pic1-f9020d050994629ea8bfea78d20edc3f.png";